import React from 'react';
import { useAuth } from '../../hooks/useAuth';
import AuthModal from '../AuthModal';

// Wrapper to connect AuthModal with AuthContext
export const AuthModalWrapper = () => {
  const { showAuthModal, closeAuthModal, handleAuthenticated } = useAuth();

  return (
    <AuthModal
      isOpen={showAuthModal}
      onClose={closeAuthModal}
      onAuthenticated={handleAuthenticated}
    />
  );
};

export default AuthModalWrapper;
